import React, { useState, useEffect } from "react";
import Live from "../../../assets/Icon/live.png";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const LiveQnA = () => {
  const [event_data, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [buffer, setBuffer] = useState(true);

  useEffect(() => {
    axios.get(`/api/star/qna_live`).then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.events);
        setCount(res.data.count);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader title="Live QnA Events" image={Live} count={count} />
      {buffer ? (
          <LoaderPost />
        ) : (
      <AllModuleData data={event_data} urlLink={`/superstar/qna/details`} qna={"true"}/>
      )}
    </>
  );
};

export default LiveQnA;
